<script>



import { useToast } from "vue-toastification";

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import UploadPhoto from '@/components/CustomWorking/WorkingProjects/uploadPhoto/uploadPhoto'


import LoadingScreen from '@/components/General/LoadingScreen'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getProject, getProjectPhotos, rotatePhoto, setDefaultPhotoToProject, deletePhoto } from '@/services/working/serviceProject';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'ProjectPhotos',
	mixins: [ MixinGeneralFunct ],
	components: {
		UploadPhoto
		,LoadingScreen

	},
	props: {'projectId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["projectId","changeRecord"],
	data() {
	
		return {
			prefix:'',
			
			params:[],
			metaData: [],
			
			isLoading:true,
			
			isNewRecord:true,

			optionsAccessLevels: [],
			optionsTypes:[],
			optionsTemplates:[],
			optionsStates:[],
			optionsLanguages:[],
					
			
			//form	
			project:[],
			photos:[],
			
			modalUpload:{},
			modalUploadId:'',
			
		}
	},
	
	mounted:function(){
		this.modalUploadId = `modal${this.getRandomInt(999999999)}`;
	},
	
	methods: {
		// load data form
		onLoadPage:function(){
			
			this.isLoading=true

			getProject({projectId:this.projectId}).then(response => {
				if(!response.statusText){
					
					this.metaData = response.metaData;
					this.project = response.data;

				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getProjectPhotos({projectId:this.projectId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.metaData = response.metaData;
					this.photos = response.photos;

				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},

		
		onClose:function(){
			this.$emit('changeRecord', '')
			this.modalObject.hide();
		},

		//modal box upload photos
		loadModalFormProjectPhotosUpload:function(){
			this.modalUpload = new bootstrap.Modal(document.getElementById(this.modalUploadId), {backdrop:'static'})
			this.modalUpload.show();
		},

		reloadAfterAddedPhoto() {
			this.onLoadPage();
		},


		//otocenie obrazku o 90
		onRotate:function(photoId){
			this.cSession();			
			this.isLoading=true
			rotatePhoto({photoId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},
		
		//vyber default obrazku
		onSelectDefault:function(photoId){
			console.log(photoId)
			console.log(this.projectId)
			this.cSession();			
			this.isLoading=true
			setDefaultPhotoToProject({photoId:photoId,projectId:this.projectId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

		//vymazanie obrazku
		onDelete:function(photoId){
			this.cSession();			
			this.isLoading=true
			deletePhoto({photoId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasDeleted'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeDeleted'));
					}else if(response.resCode==2){
						this.toast.warning(this.$t('msgCore.dataWasNotDeleted'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

	},
	
	watch: {
		projectId() {
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-lg">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCore.Preview') }} <span><b>{{ project.title }}</b> </span></h6>
						
						<button type="button" :disabled="!auth.projectPhotoUpload" v-on:click="loadModalFormProjectPhotosUpload(project.id)" :title="$t('msgCore.btnUpload')" class="btn btn-primary btn-sm"><i class=" fas fa-upload"></i> {{ $t('msgCore.Upload') }}</button>
						
					</div>
			
					<div class="modal-body">

						<div class="row">
							<div class="col-12">
								
								<div class="row">
									<div v-for="photo in photos" :key="photo" class="col-lg-3 col-md-4 col-6 ">
										<div class="row">
											<div class="col-12 crop_gallery2">
												<img :src="photo.fotoData" :title="photo.title">
											</div>
										
											<div class="col-12">
												<button type="button" :disabled="!auth.projectPhotoUpload" v-on:click="onRotate(photo.id)" :title="$t('msgCore.btnRotate')" class="btn btn-primary btn-sm"><i class=" fas fa-sync"></i></button>
												<button type="button" :disabled="!auth.projectPhotoDelete" v-on:click="onDelete(photo.id)" :title="$t('msgCore.btnRotate')" class="btn btn-danger btn-sm"><i class=" fas fa-trash-alt"></i></button>
												<button v-if="!photo.isSelected" type="button" :disabled="!auth.projectPhotoUpload" v-on:click="onSelectDefault(photo.id)" title="Vyberte hlavnú fotku" class="btn btn-warning btn-sm" ><i class=" fas fa-check"></i></button>
												<span v-if="photo.isSelected"><i class="fas fa-check text-success"></i></span>
											</div>

										</div>
									</div>
								</div>

							</div>
						</div>
			
					</div>
					
					<div class="modal-footer">
						<div class="btn-group">
							<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>

							
						</div>	
					</div>
						
				
					
					
				
				</div>

			</div>
			
		</div>
		

	
		<UploadPhoto :auth="auth" :projectId="String(projectId)" @changeAfterUpload="reloadAfterAddedPhoto" :modalObject="modalUpload" :modalId="modalUploadId"></UploadPhoto>
	</div>
</template>


